import { IconX } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useEffect, useState } from 'react';
import { IOptionAnyValue } from 'bricks/types';
import { Link, generatePath } from 'react-router-dom';
import { URLS } from 'services/urls';
import ProFormaSelector from 'views/Reports/components/ProFormaSelector/ProFormaSelector';
import { IComparisonReportData } from 'views/Reports/types';

export interface IProps {
    data: IComparisonReportData;
    removeSelectedDeal: (dealId: number) => void;
    updateSelectedProFormaId: (dealId: number, proFormaId: number) => void;
    isEditMode: boolean;
    isLoading?: boolean;
}

export const ColumnHeader = ({
    data, removeSelectedDeal, updateSelectedProFormaId, isEditMode, isLoading = false,
}: IProps) => {
    const [wasSelectionChanged, setWasSelectionChanged] = useState(false);
    const handleProFormaSelection = (option: IOptionAnyValue) => {
        setWasSelectionChanged(true);
        updateSelectedProFormaId(data.dealId, option.value);
    };

    useEffect(() => {
        if (wasSelectionChanged && !isLoading) {
            setWasSelectionChanged(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    let dealType = '';
    if (data.dealTypeName && data.dealAssetType) {
        dealType = `${data.dealAssetType} • ${data.dealTypeName}`;
    } else if (data.dealTypeName) {
        dealType = data.dealTypeName;
    } else if (data.dealAssetType) {
        dealType = data.dealAssetType;
    }

    return (
        data && (
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <div className="text-white h4">
                        <Link
                            to={generatePath(URLS.DEAL_DASHBOARD.HOME, { dealId: data.dealId.toString(), tab: 'overview' })}
                        >
                            {data.dealName}
                        </Link>
                    </div>
                    <div>{dealType}</div>
                    <ProFormaSelector
                        dealId={Number(data.dealId)}
                        proFormaId={data.proFormaId}
                        onChangeProFormaSelection={handleProFormaSelection}
                        isLoading={isLoading && wasSelectionChanged}
                        disableLandDevelopmentOptions
                    />
                </div>
                {isEditMode && (
                    <div>
                        <NSIcon className="icon my-auto cursor--pointer" icon={IconX} onClick={() => removeSelectedDeal(data.dealId)} />
                    </div>
                )}
            </div>
        )
    );
};

export default ColumnHeader;
